import {CoreModel} from '../../model/CoreModel';
import CoreMessageDispatcher from '../../controller/CoreMessageDispatcher';
import CoreEvents from '../../events/CoreEvents';

const InitiateStates = doThat => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        const model = CoreModel.instance();
        model.configStates(doThat);
        model.state = doThat.states[0];
        if (model.stateChanged) {
            model.resetStateChanged();
            CoreMessageDispatcher.instance().emit(CoreEvents.MODEL_STATE_CHANGED);
            CoreMessageDispatcher.instance().emit(CoreEvents.MODEL_CHANGED);
        }

        resolve(doThat);
    });
};

export {InitiateStates};
